const ugListSection = $('#user-guide-list');

let ugMenuGroups;// = ugListSection.find('.ug-type-group');
let ugMenuLinks;// = ugListSection.find('.ug-type-group-link');
const mobileBg = $('.ug-float-menu-bg');
const mobileMenuParent = $('.ug-float-menu');
const mobileMenuMini = mobileMenuParent.find('.float-menu-mobile-mini-parent');
const mobileMenuFull = mobileMenuParent.find('.ug-menu-types');
let ugMenuLenis;
let lastActiveGroup = undefined;
let lastActiveLink = undefined;
let destroyUGMobileMenu = () => {};
const ugMenuGroupsObj = {};
const ugMenuGroupsST = [];
const ugMenuLinksST = [];

const toggleMenuAnimation = () => {
  const menuTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      lenis.stop();
    },
    onReverseComplete: () => {
      lenis.start();
    },
  });
  menuTL.add(
    gsap.fromTo(
      mobileMenuMini,
      {
        opacity: 1,
        backdropFilter: 'blur(40px)',
      },
      {
        opacity: 0,
        backdropFilter: 'blur(0px)',
        duration: 0.33,
        ease: 'opacityInEasing',
      }
    ),
    0
  );
  menuTL.add(
    gsap.fromTo(
      mobileMenuFull,
      {
        y: '100%',
        backdropFilter: 'blur(40px)',
      },
      {
        y: 0,
        backdropFilter: 'blur(40px)',
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.33
  );
  menuTL.add(
    gsap.fromTo(
      mobileBg,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.83,
        ease: 'pageInEasing',
        onComplete: () => {
          gsap.set(mobileBg, { pointerEvents: 'all' });
        },
        onReverseComplete: () => {
          gsap.set(mobileBg, { pointerEvents: 'none' });
        },
      }
    ),
    0.33
  );

  return menuTL;
};


function changeActiveLink(toLink) {
  if (lastActiveLink == toLink) return;
  if (lastActiveLink != undefined) {
    gsap.set(lastActiveLink, { clearProps: 'all' });
    lastActiveLink.toggleClass('active');
  }
  toLink.toggleClass('active');
  lastActiveLink = toLink;
}

const setGroups = () => {
  ugMenuGroups.each(function () {
    const groupTopper = $(this).find('.ug-type-group-topper');
    const groupTopperHeight = pxToVw(groupTopper.outerHeight());
    gsap.set($(this), { height: `${groupTopperHeight}vw` });
  });
};

const toggleGroupAnimation = (group, direction) => {
  const groupTopper = group.find('.ug-type-group-topper');
  const groupInner = group.find('.ug-type-group-inner');
  const groupTopperHeight = pxToVw(groupTopper.outerHeight());
  const groupInnerHeight = pxToVw(groupInner.outerHeight());
  const toHeight = groupTopperHeight + groupInnerHeight + 0.938;
  gsap.to(group, {
    height: direction ? `${toHeight}vw` : `${groupTopperHeight}vw`,
    duration: 0.63,
    ease: 'pageInEasing',
    onComplete: () => {
      ugMenuLenis.resize();
      direction ? ugMenuLenis.scrollTo(group.get(0), { offset: -vwToPx(2.5), duration: 0.63 }) : false;
    }
  });
  gsap.to(groupInner, {
    opacity: direction ? 1 : 0,
    duration: 0.33,
    ease: 'opacityInEasing',
    delay: 0.3,
  });
  direction ? group.addClass('opened') : group.addClass('closed');
};

function changeActiveGroup(toGroup, byTrigger = false) {
  if (toGroup.is(lastActiveGroup) && !byTrigger) {
    toggleGroupAnimation(lastActiveGroup, false);
    lastActiveGroup = undefined;
    return
  }
  if (lastActiveGroup != undefined) {
    toggleGroupAnimation(lastActiveGroup, false);
  }
  toggleGroupAnimation(toGroup, true);
  lastActiveGroup = toGroup;
}

const menuLinkHover = (link, direction) => {
  if (link.attr('href') != lastActiveLink.attr('href')) {
    gsap.set(link, { color: direction ? 'var(--white-color-100)' : 'rgba(223, 229, 245, 0.7)' });
  }
};

const initUgGropsST = () => {
  ugMenuGroupsST.forEach((tr) => tr.kill());
  ugMenuGroupsST.length = 0;
  ugMenuGroups.each(function () {
    const firstGroupLink = $(this).find('.ug-type-group-link').eq(0);
    const lastGroupLink = $(this).find('.ug-type-group-link').last();
    const hrefFirst = firstGroupLink.attr('href');
    const hrefLast = lastGroupLink.attr('href');
    const anchorToElementFirst = ugListSection.find(`${hrefFirst}`);
    const anchorToElementLast = ugListSection.find(`${hrefLast}`);

    if (isDesktop()) {
      ugMenuGroupsST.push(
        ScrollTrigger.create({
          trigger: anchorToElementFirst,
          start: 'top top+=20%',
          end: 'bottom top+=20%',
          onEnter: () => {
            if (!blockTriggers) {
              changeActiveGroup($(this), true);
            }
          },
        })
      );
      ugMenuGroupsST.push(
        ScrollTrigger.create({
          trigger: anchorToElementLast,
          start: 'top top+=20%',
          end: 'bottom top+=20%',
          onEnterBack: () => {
            if (!blockTriggers) {
              changeActiveGroup($(this), true);
            }
          },
        })
      );
    }
  });
};

const initUgMenuLinksST = () => {
  ugMenuLinksST.forEach((tr) => tr.kill());
  ugMenuLinksST.length = 0;
  ugMenuLinks.each(function () {
    const href = $(this).attr('href');
    const anchorToElement = $(href);
    const elementTitle = anchorToElement.find('.ug-step-title').text();

    if (isDesktop()) {
      ugMenuLinksST.push(
        ScrollTrigger.create({
          trigger: anchorToElement,
          start: 'top top+=20%',
          end: 'bottom top+=20%',
          onEnter: () => {
            if (!blockTriggers) {
              changeActiveLink($(this));
            }
          },
          onEnterBack: () => {
            if (!blockTriggers) {
              changeActiveLink($(this));
            }
          },
        })
      );
    } else {
      ugMenuLinksST.push(
        ScrollTrigger.create({
          trigger: anchorToElement,
          start: 'top bottom-=20%',
          end: 'bottom bottom-=20%',
          onEnter: () => {
            $('.float-menu-mobile-mini-label').text(elementTitle);
          },
          onEnterBack: () => {
            $('.float-menu-mobile-mini-label').text(elementTitle);
          },
        })
      );
    }
  });
};

const addMenuGroups = () => {
  const ugMenuList = $('.float-menu-types-list');
  const groupHTMLTemplate = $('.ug-type-group-parent').eq(0);
  const stepHTMLTemplate = groupHTMLTemplate.find('.ug-type-group-link-parent');
  stepTemplate = stepHTMLTemplate.clone();
  stepHTMLTemplate.remove();
  groupTemplate = groupHTMLTemplate.clone();
  groupHTMLTemplate.remove();
  let stepIndex = 1;
  Object.entries(ugMenuGroupsObj)
  .sort(([, a], [, b]) => a.index - b.index)
  .forEach(([groupName, groupData]) => {
    const groupElement = groupTemplate.clone();
    const groupElementStepsParent = groupElement.find('.ug-type-group-inner');

    groupElement.find('.ug-type-group-number').html(`&#x246${groupData.index}`);
    groupElement.find('.ug-type-group-name').html(`${groupName}`);
    groupElement.find('.ug-type-link-mobile').html(`${groupName}`);

    groupData.steps.forEach((step) => {
      const stepElement = stepTemplate.clone();
      stepElement.find('.ug-type-group-link').html(`${step}`);
      stepElement.find('.ug-type-group-link').attr('href', `#step-${stepIndex}`);
      stepElement.find('.ug-type-group-link-mobile').html(`${step}`);
      stepElement.find('.ug-type-group-link-mobile-parent').attr('href', `#step-${stepIndex}`);
      groupElementStepsParent.append(stepElement);
      stepIndex += 1;
    });
    ugMenuList.append(groupElement)
  });
}

const initUGMobileMenu = () => {
  const mobileBackBtn = mobileMenuFull.find('.float-menu-mobile-back-btn');
  const mobileMenuList = mobileMenuFull.find('.float-menu-types-list');
  const mobileMenuListInner = mobileMenuFull.find('.float-menu-types-list-inner-placer');
  const mobileugMenuGroups = mobileMenuList.find('.ug-type-group-parent');
  const mobileMenuInnerLinksAll = mobileMenuFull.find('.ug-type-group-link-mobile-parent');
  const mobileMenuDownloadBtn = mobileMenuParent.find('.float-menu-btn-placer');

  const menuLenis = new Lenis({
    wrapper: mobileMenuList.get(0),
    autoRaf: true,
  });

  const menuInnerList = new Lenis({
    wrapper: mobileMenuListInner.get(0),
    autoRaf: true,
  })


  const menuTL = toggleMenuAnimation();

  const toggleMenuFull = (open) => {
    if (open) {
      menuTL.play();
    } else {
      menuTL.reverse();
    }
  };

  const toggleList = (open) => {
    mobileMenuList.css('display', open ? 'flex' : 'none');
    mobileMenuListInner.css('display', open ? 'none' : 'flex');
  };

  const toggleBackBtn = (open) => {
    mobileBackBtn.css('display', open ? 'flex' : 'none');
  };

  mobileMenuMini.on('click', function (e) {
    e.stopPropagation();
    toggleMenuFull(true);
  });

  mobileBg.on('click', function () {
    toggleMenuFull(false);
  });

  mobileMenuFull.on('click', function (e) {
    e.stopPropagation();
  });

  mobileBackBtn.on('click', function (e) {
    mobileMenuListInner.html('');
    toggleList(true);
    toggleBackBtn(false);
  });

  mobileMenuInnerLinksAll.on('click', function (e) {
    lenis.start();
    toggleMenuFull(false);
    toggleList(true);
    toggleBackBtn(false);
    mobileMenuListInner.html('');
  });

  mobileugMenuGroups.each(function () {
    $(this).on('click', function () {
      const innerListItmes = $(this).find('.ug-type-group-inner .ug-type-group-link-mobile-parent');
      mobileMenuListInner.append(innerListItmes.clone(true));
      toggleList(false);
      toggleBackBtn(true);
    });
  });

  destroyUGMobileMenu = () => {
    mobileMenuMini.off('click');
    mobileBg.off('click');
    mobileMenuFull.off('click');
    mobileBackBtn.off('click');
    mobileMenuInnerLinksAll.off('click');
    mobileugMenuGroups.each(function(){
      $(this).off('click');
    })
  }
};

const initUGMenu = () => {
  lenis.start();
  ugMenuGroups = ugListSection.find('.ug-type-group');
  ugMenuLinks = ugListSection.find('.ug-type-group-link');
  ugMenuLinks.off('mouseenter, mouseleave');
  gsap.set([mobileBg, mobileMenuParent, mobileMenuFull], { clearProps: 'all' });
  setGroups();

  if (!isDesktop()) {
    initUGMobileMenu();
  } else {
    ugMenuLenis = new Lenis({
      wrapper: $('.float-menu-types-list').get(0),
      autoRaf: true,
    });
    ugMenuLinks.each(function () {
      $(this).on('mouseenter', () => menuLinkHover($(this), 1));
      $(this).on('mouseleave', () => menuLinkHover($(this), 0));
    });
  }
  initUgGropsST();
  initUgMenuLinksST();

  ugMenuGroups.on('click', function () {
    changeActiveGroup($(this));
  });

  ugMenuLinks.on('click', function () {
    changeActiveLink($(this));
  });
};

const initUGList = () => {
  const listSectionsParent = $('.list-sections-parent');
  const stepsParent = $('.shopify-section:has(.ug-step-parent)');
  stepsParent.each(function (index) {
    listSectionsParent.append($(this));
  });

  const steps = $('.ug-step-parent');
  let groupIndex = 0;
  steps.each(function (index) {
    const groupName = $(this).attr('data-group');
    const stepName = $(this).attr('data-step');
    if (!ugMenuGroupsObj[groupName]) {
      ugMenuGroupsObj[groupName] = {
        index: groupIndex++,
        steps: []
      };
    }
    ugMenuGroupsObj[groupName].steps.push(stepName);

    $(this).attr('id', `step-${index + 1}`);
    $(this)
      .find('.ug-step-number')
      .text(index + 1);
  });
}

$(window).on('load', function () {
  initUGList();
  addMenuGroups();
  initUGMenu();

  $(window).on('deviceChange', function () {
    destroyUGMobileMenu();
    initUGMenu();
  });
});
